import { jsx as n, jsxs as L, Fragment as lt } from "react/jsx-runtime";
import Z, { useRef as A, useState as x, useEffect as k, memo as dt, useMemo as ut, useCallback as U } from "react";
import { Col as _, Row as ht } from "antd";
import { u as h } from "../../../styled-components.browser.esm-BFmoFexH.js";
import { F as ft } from "../../../TrashIcon-LVtkVuzL.js";
import { IconContainer as et } from "@biron-data/react-components";
import { useCurrentIcon as pt, isFilterEmpty as mt, useFilterValue as gt } from "./utils.js";
import xt from "./FilterTypeDropDown.js";
import yt from "./FilterInputs.js";
import { l as vt } from "../../../lodash-DeBCDn4U.js";
import { useLanguageResolver as wt } from "@biron-data/react-contexts";
function bt(t) {
  const i = parseFloat(t);
  return !isNaN(i) && isFinite(i);
}
function it(t) {
  return typeof t == "string" && t[t.length - 1] === "%" && bt(t.substring(0, t.length - 1));
}
function K(t, i, y) {
  i === 0 && !y && (t != null && t.style) && (t == null ? void 0 : t.children.length) > 0 && (t.style.display = "none");
}
function Ht(t, i) {
  i === 0 && (t != null && t.style) && (t.style.display = "");
}
const Tt = {
  animating: "rah-animating",
  animatingUp: "rah-animating--up",
  animatingDown: "rah-animating--down",
  animatingToHeightZero: "rah-animating--to-height-zero",
  animatingToHeightAuto: "rah-animating--to-height-auto",
  animatingToHeightSpecific: "rah-animating--to-height-specific",
  static: "rah-static",
  staticHeightZero: "rah-static--height-zero",
  staticHeightAuto: "rah-static--height-auto",
  staticHeightSpecific: "rah-static--height-specific"
};
function nt(t, i) {
  return [
    t.static,
    i === 0 && t.staticHeightZero,
    typeof i == "number" && i > 0 ? t.staticHeightSpecific : null,
    i === "auto" && t.staticHeightAuto
  ].filter((y) => y).join(" ");
}
const $t = [
  "animateOpacity",
  "animationStateClasses",
  "applyInlineTransitions",
  "children",
  "className",
  "contentClassName",
  "contentRef",
  "delay",
  "duration",
  "easing",
  "height",
  "onHeightAnimationEnd",
  "onHeightAnimationStart",
  "style",
  "disableDisplayNone"
], St = Z.forwardRef((t, i) => {
  const { animateOpacity: y = !1, animationStateClasses: b = {}, applyInlineTransitions: B = !0, children: R, className: W = "", contentClassName: P, delay: D = 0, disableDisplayNone: m = !1, duration: V = 500, easing: I = "ease", height: e, onHeightAnimationEnd: o, onHeightAnimationStart: p, style: l, contentRef: N } = t, H = Object.assign({}, t);
  $t.forEach((w) => {
    delete H[w];
  });
  const f = A(e), a = A(null), r = A(), T = A(), c = A(Object.assign(Object.assign({}, Tt), b)), E = A(typeof window < "u" && window.matchMedia ? window.matchMedia("(prefers-reduced-motion)").matches : !1), F = E.current ? 0 : D, O = E.current ? 0 : V;
  let v = e, d = "visible";
  typeof e == "number" ? (v = e < 0 ? 0 : e, d = "hidden") : it(v) && (v = e === "0%" ? 0 : e, d = "hidden");
  const [$, S] = x(v), [M, g] = x(d), [ot, z] = x(!1), [rt, q] = x(nt(c.current, e));
  k(() => {
    K(a.current, $, m);
  }, []), k(() => {
    if (e !== f.current && a.current) {
      Ht(a.current, f.current), a.current.style.overflow = "hidden";
      const w = a.current.offsetHeight;
      a.current.style.overflow = "";
      const X = O + F;
      let u, s, G = "hidden", Y;
      const J = f.current === "auto";
      typeof e == "number" ? (u = e < 0 ? 0 : e, s = u) : it(e) ? (u = e === "0%" ? 0 : e, s = u) : (u = w, s = "auto", G = void 0), J && (s = u, u = w);
      const at = [
        c.current.animating,
        (f.current === "auto" || e < f.current) && c.current.animatingUp,
        (e === "auto" || e > f.current) && c.current.animatingDown,
        s === 0 && c.current.animatingToHeightZero,
        s === "auto" && c.current.animatingToHeightAuto,
        typeof s == "number" && s > 0 ? c.current.animatingToHeightSpecific : null
      ].filter((ct) => ct).join(" "), tt = nt(c.current, s);
      S(u), g("hidden"), z(!J), q(at), clearTimeout(T.current), clearTimeout(r.current), J ? (Y = !0, T.current = setTimeout(() => {
        S(s), g(G), z(Y), p == null || p(s);
      }, 50), r.current = setTimeout(() => {
        z(!1), q(tt), K(a.current, s, m), o == null || o(s);
      }, X)) : (p == null || p(u), T.current = setTimeout(() => {
        S(s), g(G), z(!1), q(tt), e !== "auto" && K(a.current, u, m), o == null || o(u);
      }, X));
    }
    return f.current = e, () => {
      clearTimeout(T.current), clearTimeout(r.current);
    };
  }, [e]);
  const C = Object.assign(Object.assign({}, l), { height: $, overflow: M || (l == null ? void 0 : l.overflow) });
  ot && B && (C.transition = `height ${O}ms ${I} ${F}ms`, l != null && l.transition && (C.transition = `${l.transition}, ${C.transition}`), C.WebkitTransition = C.transition);
  const j = {};
  y && (j.transition = `opacity ${O}ms ${I} ${F}ms`, j.WebkitTransition = j.transition, $ === 0 && (j.opacity = 0));
  const st = typeof H["aria-hidden"] < "u" ? H["aria-hidden"] : e === 0;
  return Z.createElement(
    "div",
    Object.assign({}, H, { "aria-hidden": st, className: `${rt} ${W}`, style: C, ref: i }),
    Z.createElement("div", { className: P, style: j, ref: (w) => {
      a.current = w, N && (N.current = w);
    } }, R)
  );
}), Jt = dt(function({
  filter: i,
  close: y,
  handleFilterChange: b,
  isEditable: B = !0,
  isResumable: R = !0,
  withBackground: W,
  bordered: P = !1,
  getPopupContainer: D,
  onEdit: m,
  loadDictionaryEntries: V
}) {
  const I = wt(), e = Z.useRef(null), [o, p] = x(i), [l, N] = x(!1), H = pt(o);
  k(() => {
    p(i);
  }, [i]);
  const [f, a] = x(!1), r = ut(() => B && (!R || l || mt(o) || f) ? 1 : 0, [l, R, f, B, o]);
  k(() => {
    m == null || m(r);
  }, [r, m]);
  const T = gt(o, I), c = U((d = o) => {
    vt.isEqual(d, i) || b(d);
  }, [i, b, o]), Q = U((d) => {
    a(!1), c(d);
  }, [c]), E = U(() => {
    N(!1);
  }, []), F = U(() => {
    N(!0);
  }, []), [O, v] = x(80);
  return k(() => {
    const d = e.current, $ = new ResizeObserver((S) => {
      var M;
      if (S.length > 0)
        if (r) {
          const g = (M = S[0].target) == null ? void 0 : M.clientHeight;
          v(g == null || g === 0 ? "auto" : g);
        } else
          v(80);
    });
    return d && $.observe(d), () => {
      $.disconnect();
    };
  }, [r]), /* @__PURE__ */ n(
    St,
    {
      duration: 500,
      height: O,
      style: {
        width: "100%",
        fontSize: "13px",
        lineHeight: "20px",
        borderRadius: "4px",
        backgroundColor: "white"
      },
      children: /* @__PURE__ */ n(
        It,
        {
          className: "filterBox",
          ref: e,
          $bordered: P ? 1 : 0,
          title: i.reference.alias,
          onMouseEnter: F,
          onMouseLeave: E,
          children: /* @__PURE__ */ L(Rt, { children: [
            /* @__PURE__ */ L(Bt, { children: [
              /* @__PURE__ */ n(_, { span: 22, children: /* @__PURE__ */ n(Dt, { children: i.reference.alias }) }),
              /* @__PURE__ */ n(kt, { span: 2, onClick: y, children: r === 1 && /* @__PURE__ */ n(et, { size: 16, color: "var(--light-grey)", clickable: !0, children: /* @__PURE__ */ n(ft, {}) }) })
            ] }),
            /* @__PURE__ */ L(At, { children: [
              /* @__PURE__ */ n(Nt, { $isediting: r, children: r ? /* @__PURE__ */ n(xt, { filter: o, handleFilterChange: b, getPopupContainer: D }) : /* @__PURE__ */ n(Ct, { children: /* @__PURE__ */ n(et, { size: 16, color: "var(--light-grey)", children: /* @__PURE__ */ n(H, {}) }) }) }),
              /* @__PURE__ */ L(
                Ft,
                {
                  $isediting: r,
                  children: [
                    i.reference ? /* @__PURE__ */ n(yt, { filter: i, temporaryFilter: o, isEditable: r, handleTemporaryFilterChange: p, handleFilterChange: b, withBackground: W, getPopupContainer: D, onApply: c, onFocus: () => a(!0), onBlur: Q, loadDictionaryEntries: V }) : /* @__PURE__ */ n(lt, {}),
                    /* @__PURE__ */ n(Ot, { $isediting: r, children: /* @__PURE__ */ n(
                      jt,
                      {
                        className: "resume",
                        children: T
                      }
                    ) })
                  ]
                }
              )
            ] })
          ] })
        }
      )
    }
  );
}), Ct = h.div`
    height: 32px;
`, At = h.div`
    display: flex;
    flex-direction: row;
    line-height: 32px;
    min-height: 34px;
`, Nt = h(_)`
    padding: 0px !important;
    flex: 0 0 ${(t) => t.$isediting ? "45px" : "44px"};
    max-width: ${(t) => t.$isediting ? "45px" : "44px"};

    width: 100%;
    height: 32px;
    display: flex;
    align-items: baseline;
    justify-content: start;
    flex-direction: column;
    margin: 0;
    padding: 0;
`, Ft = h(_)`
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 0 !important;
    flex: 0 0 ${(t) => t.$isediting ? "calc(100% - 45px)" : "calc(100% - 28px)"};
    max-width: ${(t) => t.$isediting ? "calc(100% - 45px)" : "calc(100% - 28px)"};
    line-height: 20px;
    flex: 1;
    min-width: 0;
    gap: 8px;

    &&& {
        line-height: 20px !important;

        .ant-select {
            line-height: 20px !important;
        }

        .ant-select-selector {

            line-height: 20px !important;
        }
    }
`, Ot = h.div`
    overflow: hidden;
    position: absolute;
    top: 1px;
    left: 0;
    ${(t) => t.$isediting ? "display: none;" : "display: flex; flex-direction: column; justify-content: center;"};
    color: var(--light-grey);
    height: 29px;
    width: 100%;
`, jt = h.div`
    font-size: 12px;
    font-style: italic;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0em;
    text-align: left;
    overflow: hidden;
    width: 100%;
    display: -webkit-box !important;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`, kt = h(_)`
    display: flex;
    flex-direction: row;
    justify-content: end;
`, Bt = h(ht)`
    display: flex;
    align-items: center;
`, Rt = h.div`
    display: flex;
    flex-direction: column;
    -webkit-flex-grow: 1;
    flex-grow: 1;
    -webkit-flex-shrink: 1;
    flex-shrink: 1;
    overflow-x: hidden;
    overflow-y: initial;
    padding: 12px 8px 8px 12px;
    justify-content: space-between;
    min-height: 80px;
    gap: 6px;
`, Dt = h.div`
    font-size: 15px;
    font-weight: 400;
    color: var(--dark-text);
    max-height: 20px;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`, It = h.div`
    min-height: 80px;
    ${({ $bordered: t }) => t ? `border: 1px solid var(--border-color-input);
  border-radius: var(--main-border-radius);` : ""}
`;
export {
  Jt as default
};
//# sourceMappingURL=Box.js.map
